import { useState } from "react";
import { Ghost, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, Spinner } from "@/components/Common";
import { Rich } from "@/components/Rich";
import { FollowUpDialog, rowInfo } from "@/components/FollowUp";

const isRow = (r) => r && typeof r === "object" && !Array.isArray(r) && (r.company || r.company_name || r.job?.company || r.job_id);

export const GhostingPanel = ({ data }) => {
  const [row, setRow] = useState(null);
  const listKey = data && typeof data === "object" && !Array.isArray(data) ? Object.keys(data).find((k) => Array.isArray(data[k]) && data[k].some(isRow)) : null;
  const rows = Array.isArray(data) ? data.filter(isRow) : listKey ? data[listKey].filter(isRow) : [];
  const rest = listKey ? Object.fromEntries(Object.entries(data).filter(([k]) => k !== listKey)) : Array.isArray(data) ? null : data;
  return (
    <Card data-testid="ghosting-panel">
      <div className="mb-4 flex items-center gap-2"><Ghost className="h-4 w-4 text-[#D4AF37]" /><h3 className="font-display text-lg text-zinc-100">Ghosting radar</h3></div>
      {data === undefined ? <Spinner className="text-[#D4AF37]" /> : data === null ? <p className="text-sm text-zinc-500">Unavailable on your plan.</p> : (
        <div className="space-y-3">
          {rest && Object.keys(rest).length > 0 && <Rich value={rest} />}
          {rows.map((r, i) => (
            <div key={rowInfo(r).jobId || i} className="rounded-lg border border-[#27272A] bg-[#09090B]/60 p-3" data-testid={`ghosting-row-${i}`}>
              <Rich value={r} />
              <Button size="sm" variant="outline" onClick={() => setRow(r)} className="mt-3 border-[#D4AF37]/50 text-[#F3C649] hover:bg-[#D4AF37]/10" data-testid={`followup-button-${i}`}>
                <Mail className="h-3.5 w-3.5" />Draft follow-up
              </Button>
            </div>
          ))}
        </div>
      )}
      {row && <FollowUpDialog row={row} onClose={() => setRow(null)} />}
    </Card>
  );
};
